import { FaList, FaListOl } from "react-icons/fa";
import { FaListCheck } from "react-icons/fa6";
import { useGetEditor } from "../../../context/useEditorContext";
import { Seperator } from "./Seperator";
import { TopButton } from "./TopButton";
import { IconsContainer } from "./IconsContainer";

export function TextLists() {
    const editor = useGetEditor().editor.current;

    return (
        <IconsContainer>
            <TopButton
                isActive={editor?.isActive("taskList")}
                icon={<FaListCheck size={16} />}
                onClick={(e) => {
                    editor?.commands.toggleTaskList();
                    editor?.commands.focus();
                }}
                alt="Toggle task list"
            />
            <TopButton
                isActive={editor?.isActive("bulletList")}
                icon={<FaList size={16} />}
                onClick={(e) => {
                    editor?.commands.toggleBulletList();
                    editor?.commands.focus();
                }}
                alt="Toggle bullet list"
            />
            <TopButton
                isActive={editor?.isActive("orderedList")}
                icon={<FaListOl size={16} />}
                onClick={(e) => {
                    editor?.commands.toggleOrderedList();
                    editor?.commands.focus();
                }}
                alt="Toggle numbered list"
            />
            <Seperator />
        </IconsContainer>
    );
}
